import type { TowerKind } from './towers'

export type AscensionId = 'FORK_STORM' | 'OVERCLOCK_CORE' | 'BEACON_MATRIX' | 'PRISMATIC_BEAM' | 'HALVING_CANNON' | 'ZERO_KNOWLEDGE'

export interface AscensionDefinition {
  readonly id: AscensionId
  readonly towerKind: TowerKind
  readonly name: string
  readonly codename: string
  readonly description: string
  readonly damage: number
  readonly attackSpeed: number
  readonly range: number
}

export const ASCENSIONS: Record<AscensionId, AscensionDefinition> = {
  FORK_STORM: { id: 'FORK_STORM', towerKind: 'SOL', name: 'FORK STORM', codename: 'SWARM', description: 'Chain lightning jumps to 4 targets for 65% damage.', damage: 1, attackSpeed: 1, range: 1 },
  OVERCLOCK_CORE: { id: 'OVERCLOCK_CORE', towerKind: 'SOL', name: 'OVERCLOCK CORE', codename: 'VELOCITY', description: 'Increases this tower’s attack speed by 30%.', damage: 1, attackSpeed: 1.3, range: 1 },
  BEACON_MATRIX: { id: 'BEACON_MATRIX', towerKind: 'ETH', name: 'BEACON MATRIX', codename: 'SUPPORT', description: 'Consensus Aura expands to 300 range and grants +20% damage.', damage: 1, attackSpeed: 1, range: 1 },
  PRISMATIC_BEAM: { id: 'PRISMATIC_BEAM', towerKind: 'ETH', name: 'PRISMATIC BEAM', codename: 'OFFENSE', description: 'Increases this tower’s damage by 35% and range by 15%.', damage: 1.35, attackSpeed: 1, range: 1.15 },
  HALVING_CANNON: { id: 'HALVING_CANNON', towerKind: 'BTC', name: 'HALVING CANNON', codename: 'IMPACT', description: 'Increases this tower’s direct damage by 55%.', damage: 1.55, attackSpeed: 1, range: 1 },
  ZERO_KNOWLEDGE: { id: 'ZERO_KNOWLEDGE', towerKind: 'BTC', name: 'ZERO KNOWLEDGE', codename: 'PIERCE', description: 'Ignores all armor and attacks 15% faster.', damage: 1, attackSpeed: 1.15, range: 1 },
}

export const ASCENSION_IDS = Object.keys(ASCENSIONS) as AscensionId[]

export function ascensionsFor(kind: TowerKind): readonly AscensionDefinition[] {
  return ASCENSION_IDS.map((id) => ASCENSIONS[id]).filter((ascension) => ascension.towerKind === kind)
}
